import { escapeJSONControlChars, isPrimitve, parsePlatformArray } from '../../helpers/utils';
import { getExpressionParser } from '../../modules/expressionParser';
export const createAccessPropertyParser = () => {
    const expressionParser = getExpressionParser();
    const parse = async (data) => {
        const { objectReference, accessPath } = data.data;
        const { value } = await expressionParser.parseAndDecode(objectReference, 'unwrap');
        const parsedObject = parseObject(value);
        const { value: path } = await expressionParser.parse(accessPath, 'strip');
        let parsedValue = '';
        if (parsedObject) {
            const accessedValue = path.split('.').reduce((result, key) => {
                if (!isPrimitve(result)) {
                    if (Array.isArray(result)) {
                        result = result[parseInt(key)];
                    }
                    else {
                        result = result[key];
                    }
                }
                return result;
            }, parsedObject);
            if (isPrimitve(accessedValue)) {
                parsedValue = accessedValue;
            }
            else {
                parsedValue = JSON.stringify(accessedValue);
                if (Array.isArray(accessedValue)) {
                    parsedValue = `{${parsedValue.substring(1, parsedValue.length - 1)}}`;
                }
            }
        }
        return {
            value: `${parsedValue}`,
            isPlainText: true
        };
    };
    const parseObject = (data) => {
        try {
            // handle parsing object
            const sanitizedData = escapeJSONControlChars(data);
            const value = JSON.parse(sanitizedData);
            if (['boolean', 'number'].includes(typeof value)) {
                // since JSON parser can parse valid boolean and number strings to actual primitive values, so we return an array instead 
                return [value];
            }
            return value;
        }
        catch (err) {
            // otherwise, JSON is not valid, handle parsing arrays
            const parsedArray = parsePlatformArray(data);
            return parsedArray;
        }
    };
    return {
        parse
    };
};
